import {useMutation} from "@tanstack/react-query"

import {api, SendSMSReplyRequest, SendSMSReplyResponse} from "./index"

type SendSMSReplyParams = {
	customerID: string
	conversationID: string
	providerMessageId: string
} & SendSMSReplyRequest

export function useSendSMSReply() {
	return useMutation({
		mutationFn: ({
			customerID,
			conversationID,
			providerMessageId,
			...payload
		}: SendSMSReplyParams): Promise<SendSMSReplyResponse> =>
			api.customer.sendSMSReply(customerID, conversationID, providerMessageId, payload),
	})
}
